import './contact-view-histo-popin.component.ajscss';

import { ChatMessage } from '@agent/agent-interface/contact-view/chat/model/chat-message';
import { AgentImageService } from '@agent/agent-interface/contact-view/chat/services/agent-image.service';
import { ChatEmojiService } from '@agent/agent-interface/contact-view/chat/services/chat-emoji.service';
import { ChatMessageUtilService } from '@agent/agent-interface/contact-view/chat/services/chat-message-util.service';
import { IAgentConfigDeprecatedService } from '@agent/core/agent/agent-config-deprecated.service';
import { MailBasketAction } from '@agent/core/basket';
import { IBasketStore } from '@agent/core/basket/basket.store';
import { IChatService } from '@agent/core/channel-digit/chat/chat.service';
import { IChatDiscussion } from '@agent/core/channel-digit/chat/models/chat-discussion';
import { IChatbotService } from '@agent/core/channel-digit/chatbot/chatbot.service';
import { IChatbotDiscussion } from '@agent/core/channel-digit/chatbot/models/chatbot-discussion';
import { IEpticaDeprecatedService } from '@agent/core/channel-digit/mail/eptica/eptica-deprecated.service';
import { IEpticaRequestFrame } from '@agent/core/channel-digit/mail/eptica/models/eptica.request.interfaces';
import { ISocialNetworkService } from '@agent/core/channel-digit/social-network/social-network.service';
import { IAppointmentDeprecatedService } from '@agent/core/contact/appointment-deprecated.service';
import { IContactDeprecatedService } from '@agent/core/contact/contact-deprecated.service';
import { IContactHistoryService } from '@agent/core/contact/history/contact-history.service';
import { HistoryPopinMode, REFRESH_INPROCESS_INTERACTIONS } from '@agent/core/contact/history/models/history-models';
import { IUnitOutgoingCallDeprecatedService } from '@agent/core/phone/outcall/unit-outgoing-call-deprecated.service';
import { IRecordDeprecatedService } from '@agent/core/phone/record-deprecated.service';
import { SessionDeprecatedService } from '@commons/core/auth/session-deprecated.service';
import { ModalService } from '@commons/core/ui/modal/modal.service';
import { IEpticaExctractEvent } from '@commons/history/history-mail/models/eptica-extract';
import { ITimelineEntry } from '@commons/history/timeline//models/timeline-entry';
import { IContactEntryContent } from '@commons/models/contact-entry';
import { ITimelineEntryResult } from '@commons/history/timeline//models/timeline-entry-result';
import { Appointment, AppointmentStatus, IAppointment, IVisioAppointmentDetail, IVisioAppointmentUser } from '@commons/models/appointment';
import { IContact } from '@commons/models/contact';
import { ContactEntryNotHandledReason, ContactEntryVisibilityType, IContactEntry } from '@commons/models/contact-entry';
import { InteractionStatus } from '@commons/models/contact-interaction';
import { Audio, Playlist } from '@commons/toolbox/media-player/models/audio';
import { ChannelUtil } from '@commons/util/helper/channel';
import { deepCopy } from '@commons/util/helper/helper';
import { ng1Destroy } from '@commons/util/utilities/rx';
import { EXTERNAL_ROUTING_NAME, RESPONSE_AUTO_UUID } from '@history/core/history-deprecated.service';
import { IComponentController, IComponentOptions, ILogService, IPromise, isArray, isDefined, isUndefined } from 'angular';
import { i18n } from 'i18next';
import { filter, finalize, from, map, merge, mergeMap, tap, toArray } from 'rxjs';

import {
  AppointmentFacade,
  BookingFacade,
  CampaignType,
  capitalize,
  ChannelDirection,
  ChannelIconPipe,
  ChannelType,
  Customer,
  CustomerFacade,
  DisplayDeprecatedComponent,
  LoaderDeprecatedService,
  MailFacade,
  MediaType,
  MessagingService,
  MomentService,
  None,
  Option,
  ProfileFacade,
  ProfileService,
  RecordEntry,
  Skill,
  TileFacade,
  TileId,
  TimeSlot,
  TimeSlotType,
} from '@contact/upgrade';

import templateUrl from './contact-view-histo-popin.component.ajs.html';
import { HistoryService } from '@history/core/history.service';

export interface ModalParamContactHisto {
  // the contact selected by the csr, used to be highlighted on init
  selectContactEntry: ITimelineEntry;
  // the current contact, used to refresh the popin if changed
  contactCalling: Option<IContact>;
  // used to check how to display the 360 visibility mail, with or without permission
  checkVisibilityMail: Option<boolean>;
  // used to know if inProcess actions are allowed or not
  inProcessActionsAllowed: Option<boolean>;
  // used to indicate if simplify mode is used
  simplePanelModeApplied: Option<boolean>;
}

export type ContactHistoDialogResolver = {
  [K in keyof ModalParamContactHisto]?: () => ModalParamContactHisto[K];
};

const MODULE_NAME = 'contactContactViewHistoPopin';
const NB_HISTO_TO_LOAD: number = 50;
const NB_INPROCESS_TO_LOAD: number = 50;
const FIVE_MINUTES: number = 5 * 60 * 1000;

export class ContactViewHistoInteractionsPopinCtrl extends DisplayDeprecatedComponent implements IComponentController {
  public name = MODULE_NAME;
  close: Function;
  resolve: Function;
  msg: ChatMessage;
  selectContact: Option<IContact>;
  selectCustomer: Customer | undefined = undefined;
  selectTimelineEntry: ITimelineEntry | undefined;
  selectSkills: string[];
  currentQualifContactList: IContactEntry[];
  applicationId: string;

  simplePanelModeApplied: boolean = false;

  // List
  timelineInProcess: ITimelineEntry[] = [];
  timelineInProcessToDisplay: ITimelineEntry[] = [];
  timelineHisto: ITimelineEntry[] = [];
  timelineTreatment: ITimelineEntry[] = [];

  // cngMediaPlayer
  playlist: Playlist;
  currentAudio: Audio;
  currentRecordRow: RecordEntry;
  hasRecord: boolean = false;
  outStrategyRecord: boolean = false;
  currentContactName: string;
  historyPopinMode: HistoryPopinMode = '';
  showQualification: boolean = true;
  isRestrictedRecord = false;
  // Mail
  epticaRequestId: string;
  responseId: string;
  entryState: string;
  currentInteractionId: string | undefined;
  mailEvents: IEpticaExctractEvent[] = [];
  dimeloEvents: any;
  inProcessActionsAllowed: boolean;
  hasMailInProcess: boolean;
  disableReopen: boolean;
  displayReopen: boolean = false;

  // infinite scroll
  busy: boolean = true;
  maxPreviousExchanges: number = 0;
  busyInProcess: boolean = false;
  maxPreviousInProcessExchanges: number = 0;
  // Survey
  canShowSurveyResults: boolean = false;
  private urlListenRespMessage: string;
  public epticaPromise: IPromise<IEpticaRequestFrame>;
  // used to save epticaIds in order to hide or remove them
  private epticaFrameIds: string[] = [];
  private checkVisibilityMail = true;

  private currentCsrId: string;
  // visio appointment
  currentVisioAppointmentDetail: IVisioAppointmentDetail | undefined;
  // To tell if the visio appointment details has been loaded
  hasVisioAppointmentDetail: boolean = false;

  currentChatDiscussion: IChatDiscussion;

  constructor(
    private readonly $log: ILogService,
    private readonly sessionDeprecatedService: SessionDeprecatedService,
    private readonly recordDeprecatedService: IRecordDeprecatedService,
    private readonly agentHistory: IContactHistoryService,
    private readonly appointmentDeprecatedService: IAppointmentDeprecatedService,
    private readonly epticaDeprecatedService: IEpticaDeprecatedService,
    private readonly messaging: MessagingService,
    private readonly agentConfigDeprecatedService: IAgentConfigDeprecatedService,
    private readonly contactDeprecatedService: IContactDeprecatedService,
    private readonly timeUtil: MomentService,
    private readonly modalService: ModalService,
    private readonly loaderDeprecatedService: LoaderDeprecatedService,
    private readonly socialNetworkService: ISocialNetworkService,
    private readonly chatService: IChatService,
    private readonly chatbotService: IChatbotService,
    private readonly $i18next: i18n,
    private readonly emojiService: ChatEmojiService,
    private readonly unitOutgoingCallDeprecatedService: IUnitOutgoingCallDeprecatedService,
    private readonly profileFacade: ProfileFacade,
    private readonly appointmentFacade: AppointmentFacade,
    private readonly $sce: any,
    private readonly chatMessageUtilService: ChatMessageUtilService,
    private readonly agentImageService: AgentImageService,
    private readonly profileService: ProfileService,
    private readonly basketStore: IBasketStore,
    private readonly contactFacade: BookingFacade,
    private readonly mailFacade: MailFacade,
    private readonly tileFacade: TileFacade,
    private readonly customerFacade: CustomerFacade,
    private readonly historyService: HistoryService
  ) {
    super();
  }

  get isAuthorizedEntry(): boolean {
    return this.selectTimelineEntry ? this.selectTimelineEntry.visibilityType === ContactEntryVisibilityType.AUTHORIZED : false;
  }

  get isRestrictedEntry(): boolean {
    return this.selectTimelineEntry ? this.selectTimelineEntry.visibilityType === ContactEntryVisibilityType.RESTRICTED : false;
  }

  get isPrivateEntry(): boolean {
    return this.selectTimelineEntry ? this.selectTimelineEntry.visibilityType === ContactEntryVisibilityType.PRIVATE : false;
  }

  get displayMainZone(): boolean {
    return (
      this.historyPopinMode !== 'NOT_ALLOWED' &&
      !this.isPrivateEntry &&
      this.selectTimelineEntry != null &&
      (this.selectTimelineEntry.contactEntry != null ||
        ((this.selectTimelineEntry.canalName === 'PHONE' || this.selectTimelineEntry.canalName === 'VISIO') &&
          this.selectTimelineEntry.canalDirection === 'OUTGOING' &&
          this.selectTimelineEntry.appointment != null))
    );
  }

  buildContactFromContactEntry(timelineEntry: ITimelineEntry): Option<IContact> {
    if (!isDefined(timelineEntry) || (!isDefined(timelineEntry.contactEntry) && !isDefined(timelineEntry.appointment))) return None;

    let fromContactEntry = timelineEntry.contactEntry;
    let fromAppointment = timelineEntry.appointment;

    if (fromContactEntry) {
      let toContact = this.contactDeprecatedService.buildFakeContact(fromContactEntry.contactUuid || '');
      toContact = {
        ...toContact,
        phoneNumber: '',
        channel: {
          type: ChannelType[fromContactEntry.canalName as string],
          direction: ChannelDirection[fromContactEntry.canalDirection as string],
        },
        customerName: `${fromContactEntry.contactFirstName} ${fromContactEntry.contactLastName}`,
      };
      switch (fromContactEntry.canalName) {
        case ChannelType.PHONE:
        case ChannelType.UNITARY_PHONE:
        case ChannelType.SMS:
          toContact = {
            ...toContact,
            phoneNumber: fromContactEntry.contactUri,
          };
          break;
        case ChannelType.MAIL:
        default:
          break;
      }
      this.customerFacade.load(fromContactEntry.contactUuid);
      return Option.of(toContact as IContact);
    }

    if (fromAppointment) {
      let toAppointment = this.contactDeprecatedService.buildFakeContact(fromAppointment.customerCardUuid || '');
      toAppointment = {
        ...toAppointment,
        phoneNumber: fromAppointment.phone,
        customerName: `${fromAppointment.firstName} ${fromAppointment.lastName}`,
      };
      this.customerFacade.load(fromAppointment.customerCardUuid);
      return Option.of(toAppointment as IContact);
    }
    return None;
  }

  $onInit(): void {
    this.tileFacade.selectedId$.subscribe(selectedId => (this.applicationId = selectedId || ''));
    this.epticaRequestId = this.getEpticaRequestId() || '';
    this.disableReopen = false;

    // read the modal parameter, type of ModalParamContactHisto
    let param: ModalParamContactHisto = this.resolve();

    // refresh the appointment part if new one has been created/deleted
    this.messaging
      .forLocal()
      .listen$(REFRESH_INPROCESS_INTERACTIONS)
      .pipe(ng1Destroy(this))
      .subscribe(() => this.refreshTimelineInProcess());

    // record part
    this.recordDeprecatedService.getRecordStreamUrl().subscribe(url => (this.urlListenRespMessage = url));

    if (isDefined(param)) {
      this.simplePanelModeApplied = Option.of(param.simplePanelModeApplied).getOrElse(Option.of(false)).get();
      this.checkVisibilityMail = Option.of(param.checkVisibilityMail).getOrElse(Option.of(true)).get();
      this.inProcessActionsAllowed = Option.of(param.inProcessActionsAllowed)
        .flatMap(v => v)
        .getOrElse(true);
      this.selectContact = param.selectContactEntry ? this.buildContactFromContactEntry(param.selectContactEntry) : param.contactCalling;

      // fill in phoneNumber if possible
      if (isUndefined(this.selectContact.get().phoneNumber) || this.selectContact.get().phoneNumber.length === 0) {
        this.contactDeprecatedService.getCustomerAddresses(this.selectContact.get().responseId).then(addresses => {
          addresses
            .filter(address => address.channel.type === ChannelType.PHONE)
            .map(address => {
              this.selectContact = this.selectContact.map(c => ({
                ...c,
                phoneNumber: address.uri,
              }));
            });
        });
      }

      this.selectContact.map(_contact => {
        this.responseId = Option.of(_contact.responseId).getOrElse('');
        this.currentInteractionId = _contact.currentInteractionId;

        this.contactDeprecatedService.getCustomer(_contact.responseId).then(customer => {
          this.selectCustomer = customer;
          if (!!customer && (customer.lastname || customer.firstname)) {
            let customerCompanyName = '';
            if (customer.companyname) {
              customerCompanyName = ' - ' + capitalize(customer.companyname);
            }
            this.currentContactName =
              (customer.lastname ? customer.lastname : '') + (customer.firstname ? ' ' + customer.firstname + customerCompanyName : '');
          } else if (
            !!_contact.customerName &&
            !_contact.customerName.startsWith('undefined') &&
            _contact.customerName.trim() !== '' &&
            _contact.customerName.indexOf('unknown') < 0
          ) {
            this.currentContactName = _contact.customerName;
          } else {
            this.currentContactName = this.$i18next.t('agent:contact.info.popin.unknownContact');
          }
        });

        if (!this.simplePanelModeApplied) {
          this.refreshTimeline(_contact, [], [], () => {
            this.selectTimelineEntry = param.selectContactEntry;
            if (!this.selectTimelineEntry) {
              // select the first histo interaction if no interaction in parameter
              if (this.timelineHisto.length > 0) {
                this.selectTimelineEntry = this.timelineHisto[0];
              } else if (this.timelineInProcess.length > 0) {
                this.selectTimelineEntry = this.timelineInProcess[0];
              }
            }
            if (this.selectTimelineEntry) {
              // if entry not found, add it
              if (this.selectTimelineEntry.contactEntry) {
                // in process
                if (
                  this.selectTimelineEntry.contactEntry.interactionStatus === InteractionStatus[InteractionStatus.OPENED] &&
                  !this.existEntry(this.timelineInProcess, this.selectTimelineEntry.id)
                ) {
                  this.timelineInProcess.push(this.selectTimelineEntry);
                  this.timelineInProcessToDisplay.push(this.selectTimelineEntry);
                  // fix to force child component to be refreshed
                  this.timelineInProcess = deepCopy(this.timelineInProcess);
                  this.timelineInProcessToDisplay = deepCopy(this.timelineInProcessToDisplay);
                }
                // histo
                if (
                  this.selectTimelineEntry.contactEntry.interactionStatus === InteractionStatus[InteractionStatus.CLOSED] &&
                  !this.existEntry(this.timelineHisto, this.selectTimelineEntry.id)
                ) {
                  this.timelineHisto.push(this.selectTimelineEntry);
                  // fix to force child component to be refreshed
                  this.timelineHisto = deepCopy(this.timelineHisto);
                }
              }
              this.timelineInProcess
                .filter(timeline => !!this.selectTimelineEntry && timeline.id === this.selectTimelineEntry.id)
                .forEach(timeline => this.changeCurrentInProcessRow(timeline));
              this.timelineHisto
                .filter(timeline => !!this.selectTimelineEntry && timeline.id === this.selectTimelineEntry.id)
                .forEach(timeline => this.changeCurrentHistoryRow(timeline));
            }
            this.busy = false;
          });
        } else {
          if (!!param.selectContactEntry.contactEntry && !!param.selectContactEntry.contactEntry.id) {
            this.agentHistory.retrieveInteractionDetails(param.selectContactEntry.contactEntry.id).subscribe(
              stm => {
                this.changeContactEntry(
                  stm,
                  !!stm.contactEntry &&
                    !!stm.contactEntry.interactionStatus &&
                    stm.contactEntry.interactionStatus === InteractionStatus[InteractionStatus.CLOSED]
                    ? 'HISTO'
                    : 'INPROCESS'
                );
              },
              error => {
                this.$log.error(error);
                if (!!param.selectContactEntry.contactEntry && !!param.selectContactEntry.contactEntry.interactionStatus) {
                  this.changeContactEntry(
                    param.selectContactEntry,
                    !!param.selectContactEntry.contactEntry &&
                      !!param.selectContactEntry.contactEntry.interactionStatus &&
                      param.selectContactEntry.contactEntry.interactionStatus === InteractionStatus[InteractionStatus.CLOSED]
                      ? 'HISTO'
                      : 'INPROCESS'
                  );
                }
              }
            );
          }
        }
      });
    } else {
      this.$log.error('[ContactViewHistoInteractionsPopinCtrl] missing compulsory modal parameter');
    }

    // Get survey rights
    this.canShowSurveyResults = this.sessionDeprecatedService.hasPermission('CSR::crud_survey:read_result');

    // get current csr id
    this.profileFacade.id$.pipe(ng1Destroy(this)).subscribe(id => (this.currentCsrId = id));
    this.agentImageService.loadImage(this.currentCsrId);
    this.profileService.picture$.pipe(ng1Destroy(this)).subscribe(picture => this.agentImageService.setPicture(this.currentCsrId, picture));
  }

  existEntry(entries: ITimelineEntry[], id: string): boolean {
    return entries.some(tl => tl.id === id);
  }

  getAgentPicture(id: string): string | undefined {
    return this.agentImageService.getPicture(id);
  }

  agentHaveProfilePicture(id: string): boolean {
    return !!this.getAgentPicture(id);
  }

  getNextPreviousExchanges(_from: number): void {
    if (this.busy) {
      return;
    }
    this.busy = true;

    //  let's find all the data
    if (isUndefined(this.timelineHisto)) {
      this.timelineHisto = [];
    }

    if (_from >= this.timelineHisto.length && _from <= this.maxPreviousExchanges) {
      this.selectContact.forEach(_contact =>
        this.agentHistory
          .findHistory({
            from: _from,
            size: NB_HISTO_TO_LOAD,
            contact: _contact,
          })
          .subscribe((result: ITimelineEntryResult) => {
            let myVals = {};
            this.timelineHisto = this.timelineHisto.concat(result.timeline).filter((entry: ITimelineEntry) => {
              // uniq filter
              if (myVals[entry.id]) {
                return false;
              }
              myVals[entry.id] = true;
              return true;
            });
            this.maxPreviousExchanges = result.total;
            this.busy = false;
          })
      );
    } else {
      this.busy = false;
    }
  }

  getNewTreatments(entry: IContactEntry) {
    this.agentHistory.findTreatments(entry, this.epticaPromise).subscribe(
      (result: ITimelineEntryResult) => {
        this.timelineTreatment = result.timeline;
      },
      err => this.$log.error(`[Histo Popin] error during search new treatment (${err})`),
      () => {
        let contents = this.getCurrentContents();
        from(this.timelineTreatment)
          .pipe(
            filter(() => isDefined(this.selectTimelineEntry)),
            filter(
              () =>
                !!this.selectTimelineEntry &&
                this.selectTimelineEntry.canalName !== ChannelType[ChannelType.SMS] &&
                this.selectTimelineEntry.canalName !== ChannelType[ChannelType.CHAT_IADVIZE]
            ),
            filter(() => isDefined(contents) && isArray(contents)),
            mergeMap((e: ITimelineEntry) =>
              from(contents).pipe(
                filter(element => !!element && !!element.content && element.contentType === 'FORM'),
                map(() => e)
              )
            ),
            toArray()
          )
          .subscribe(
            (timeline: ITimelineEntry[]) =>
              (this.currentQualifContactList = this.currentQualifContactList.concat(
                timeline.filter(e => !!e && !!e.contactEntry && !!e.contactEntry.id).map(t => t.contactEntry!)
              ))
          );
      }
    );
  }

  public getNextTimelineInProcess(_from: number): void {
    if (this.busyInProcess) {
      return;
    }

    this.busyInProcess = true;

    if (_from >= this.timelineInProcess.length && _from <= this.maxPreviousInProcessExchanges) {
      this.agentHistory
        .findInProcess({ contact: this.selectContact.get(), entriesToMatch: [], from: _from, size: NB_INPROCESS_TO_LOAD })
        .pipe(
          tap((_result: ITimelineEntryResult) => {
            let myVals = {};
            this.timelineInProcess = this.timelineInProcess.concat(_result.timeline).filter((entry: ITimelineEntry) => {
              // uniq filter
              if (myVals[entry.id]) {
                return false;
              }
              myVals[entry.id] = true;
              return true;
            });
            this.timelineInProcessToDisplay = this.timelineInProcess.filter(
              tm => tm.canalName !== ChannelType.MAIL || tm.isEpticaSynchronized
            );
            this.maxPreviousInProcessExchanges = _result.total;
          }),
          finalize(() => (this.busyInProcess = false))
        )
        .subscribe();
    } else {
      this.busyInProcess = false;
    }
  }

  playRecord(): void {
    const audio = this.getCurrentAudioFile();
    if (audio) {
      this.currentAudio = audio;
    }
  }

  onChangeAudio({ audio }): void {
    this.currentAudio = audio;
  }

  // record functions
  getCurrentAudioFile(): Audio | undefined {
    if (this.selectTimelineEntry && this.selectTimelineEntry.contactEntry) {
      let _caf: Audio = {
        title: '[' + this.selectTimelineEntry.contactEntry.contactUri + '] ',
        url: this.urlListenRespMessage + encodeURIComponent(this.selectTimelineEntry.contactEntry.technicalId),
      };
      return _caf;
    }
    return undefined;
  }

  isModalReduced(): boolean {
    return this.modalService.isModalReduced();
  }

  reduce(): void {
    this.modalService.reduce();
  }

  unreduce(): void {
    this.modalService.unreduce();
  }

  bye(): void {
    this.epticaDeprecatedService.removeFrames(this.epticaFrameIds);
    this.epticaFrameIds = [];

    // Modal closing
    this.modalService.close();
  }

  closeRequestCallback(): void {
    this.historyPopinMode = '';
    this.epticaPromise.then(() =>
      this.selectContact.map(contact => {
        if (this.selectTimelineEntry) {
          this.refreshTimeline(contact, [], [this.selectTimelineEntry], () => this.changeContactEntry(this.selectTimelineEntry!, 'HISTO'));
        }
      })
    );
  }

  assignRequestCallback(): void {
    this.historyPopinMode = '';
    this.epticaPromise.then(() => {
      if (this.selectTimelineEntry) {
        this.selectTimelineEntry.responsibleId = parseInt(this.epticaDeprecatedService.getMailAccountId(), 10);
        this.changeContactEntry(this.selectTimelineEntry, 'INPROCESS');
      }
    });
  }

  /**
   * Change element, so recalculate the right part
   */
  changeCurrentHistoryRow(_row: ITimelineEntry) {
    this.changeContactEntry(_row, 'HISTO');
  }

  /**
   * Change inProcess element, so recalculate the middle and right part
   */
  changeCurrentInProcessRow(_row: ITimelineEntry) {
    this.changeContactEntry(_row, 'INPROCESS');
  }

  /**
   * A new interaction has been selected on the treatment part
   */
  treatmentSelected(_row: ITimelineEntry) {
    // this.$log.debug("[ContactViewHistoPopin] new treatment row [" + JSON.stringify(_row) + "]");
    let mode: HistoryPopinMode = Option.of(_row.contactEntry)
      .flatMap(entry => Option.of(entry.interactionStatus))
      .map(status => (InteractionStatus[status] === InteractionStatus.OPENED ? 'INPROCESS' : 'HISTO'))
      .getOrElse('HISTO');
    this.changeContactEntry(_row, mode);
  }

  /**
   * To tell if the timeline entry contains appointment (call or visio)
   */
  isScheduleCallbackContact(): boolean {
    return (
      !!this.selectTimelineEntry &&
      !!this.selectTimelineEntry.appointment &&
      (this.selectTimelineEntry.appointment.campaignType === this.getCampaignType('SCHEDULED_CALL_BACK') ||
        this.selectTimelineEntry.appointment.campaignType === this.getCampaignType('VISIO_SCHEDULED_CALL_BACK'))
    );
  }

  /**
   * To tell if the timeline entry contains a visio appointment or was created from a visio appointment
   */
  isVisioAppointment(): boolean {
    return (
      !!this.selectTimelineEntry &&
      ((!!this.selectTimelineEntry.appointment &&
        this.selectTimelineEntry.appointment.campaignType === this.getCampaignType('VISIO_SCHEDULED_CALL_BACK')) ||
        (!!this.selectTimelineEntry.contactEntry && this.selectTimelineEntry.canalName === ChannelType[ChannelType.VISIO]))
    );
  }

  postPoneContact() {
    if (this.selectTimelineEntry && this.selectTimelineEntry.appointment && !this.selectTimelineEntry.appointment.closed) {
      this.appointmentDeprecatedService.openPostPoneAppointmentForm(this.selectTimelineEntry.appointment).subscribe(null, null, () => {
        let currentSelectedId: string = this.selectTimelineEntry!.id;
        this.selectTimelineEntry = undefined;
        this.selectContact.map(_contact =>
          this.agentHistory.findInProcess({ contact: _contact }).subscribe((_result: ITimelineEntryResult) => {
            this.timelineInProcess = _result.timeline;
            this.timelineInProcess
              .filter((timeline: ITimelineEntry) => timeline.id === currentSelectedId)
              .forEach((timelineEntryToReselect: ITimelineEntry) => {
                this.selectTimelineEntry = timelineEntryToReselect;
              });
            this.timelineInProcessToDisplay = this.timelineInProcess.filter(
              tm => tm.canalName !== ChannelType.MAIL || tm.isEpticaSynchronized
            );
          })
        );
      });
    }
  }

  getCampaignTypeString(type: CampaignType): string {
    return CampaignType[type] + '_SHORT';
  }

  getCampaignType(typeSt: string): CampaignType {
    return CampaignType[typeSt];
  }

  /**
   * Remove the selected appointment
   */
  removeAppointment(_appointment: ITimelineEntry) {
    // this.$log.debug("[ContactViewHistoPopin] removeAppointment row: [" + JSON.stringify(_appointment) + "]");
    let tmp: IAppointment = new Appointment();
    tmp.idContact = _appointment.id;
    // the only important thing is the id of the appointment (witch is the contact of the campaign)
    this.appointmentDeprecatedService.deleteAppointment(tmp);
  }

  /**
   * Find a record from its technicalId
   */
  getNewRecord(techId: string) {
    if (isDefined(techId)) {
      this.historyService
        .getRecordStatus(techId)
        .pipe(
          map(_status => {
            this.hasRecord = _status === 'AVAILABLE' || _status === 'RESTRICTED';
            this.isRestrictedRecord = _status === 'RESTRICTED';
            this.outStrategyRecord = _status === 'OUT_STRATEGY';
          }),
          ng1Destroy(this)
        )
        .subscribe();
    }
  }

  readableDateTimeNoSep(dateToConvert: Date): string {
    return this.timeUtil.readableDateTimeNoSep(dateToConvert);
  }

  readableDateTime(dateToConvert: Date): string {
    return this.timeUtil.readableDateTime(dateToConvert);
  }

  readableDateShort(dateToConvert: Date) {
    return this.timeUtil.readableDateShort(dateToConvert);
  }

  /**
   * Return the first content of the current interaction if it is a SMS
   */
  getCurrentContentSMS(): string {
    let ret = '';
    let contents = this.getCurrentContents();
    if (
      this.selectTimelineEntry &&
      this.selectTimelineEntry.canalName === ChannelType[ChannelType.SMS] &&
      isArray(contents) &&
      isDefined(contents) &&
      contents.length > 0
    ) {
      ret = contents[0].content;
    }
    return ret;
  }

  linkTimeline(elements: ITimelineEntry[]) {
    this.contactDeprecatedService.getSelectedContact().then(contact => {
      this.$log.info('[ContactViewHistoInteractionsPopinCtrl] linked [' + JSON.stringify(elements) + ']');
      this.loaderDeprecatedService.active('Area-InProcessContact-popin', 'Area-historyContact-popin-left-histo');
      let lastMode = this.historyPopinMode;

      // If current interaction is in list, we mask button
      if (elements.some(entry => !!this.selectTimelineEntry && entry.id === this.selectTimelineEntry.id)) {
        this.historyPopinMode = '';
        this.epticaPromise.then(request => request.hide());
      }

      let link$ = elements
        .filter(time => !!time.contactEntry)
        .map(time => this.epticaDeprecatedService.safeLinkRequest(`${time.contactEntry!.epticaRequestId}`, contact.connectionId));

      let success: string[] = [];
      merge(...link$).subscribe(
        (id: number) => success.push(id.toString()),
        err => this.$log.error(`[Histo Popin] error during link timeline (${err})`),
        () => {
          // Partition request error/success
          let timelineError = elements.filter(
            entry => !success.some(id => !!entry.contactEntry && id === entry.contactEntry.epticaRequestId)
          );
          let timelineSuccess = elements.filter(entry =>
            success.some(id => !!entry.contactEntry && id === entry.contactEntry.epticaRequestId)
          );

          // Refresh zone
          this.refreshTimeline(contact, timelineError, timelineSuccess, () => {
            if (
              this.selectTimelineEntry &&
              success.some(
                id =>
                  !!this.selectTimelineEntry &&
                  !!this.selectTimelineEntry.contactEntry &&
                  id === this.selectTimelineEntry.contactEntry.epticaRequestId
              )
            ) {
              this.changeContactEntry(this.selectTimelineEntry, 'HISTO');
            } else if (this.selectTimelineEntry) {
              this.changeContactEntry(this.selectTimelineEntry, lastMode);
            }
            this.loaderDeprecatedService.dispose('Area-InProcessContact-popin', 'Area-historyContact-popin-left-histo');
          });
        }
      );
    });
  }

  getSurveyContent() {
    if (this.selectTimelineEntry && this.selectTimelineEntry.contactEntry) {
      // we need to check that the element is not undefined
      const toParse = this.selectTimelineEntry.contactEntry?.contents?.find(content => content.contentType == 'SURVEY');
      if (toParse && toParse.content) {
        return JSON.parse(toParse.content);
      }
    }
    return undefined;
  }

  getIconClass(): string {
    const entry = this.selectTimelineEntry;
    const channelIconPipe = new ChannelIconPipe();

    if (!entry) {
      return '';
    }

    if (entry.canalName === MediaType.SOCIAL_NETWORK) {
      return channelIconPipe.transform({
        type: entry.canalName,
        direction: undefined,
      });
    }

    if (entry.canalName === MediaType.CHATBOT || entry.canalName === MediaType.CHAT) {
      return channelIconPipe.transform({
        type: entry.canalName,
        direction: undefined,
      });
    }

    return channelIconPipe.transform({
      type: entry.canalName,
      direction: entry.canalDirection,
    });
  }

  getMessageContent(message: string): string {
    let text = this.chatMessageUtilService.processContent(message);
    return this.emojiService.emojify(text);
  }

  getUrl(text: string) {
    return this.$sce.trustAsHtml(this.chatMessageUtilService.processUrl(text));
  }

  getRecordListenTitle(): string {
    if (this.isRestrictedRecord) {
      return this.$i18next.t('agent:records.restricted');
    }
    return this.$i18next.t('agent:records.actions.listen');
  }

  getCsrLabel(): string {
    if (this.selectTimelineEntry && this.selectTimelineEntry.contactEntry) {
      if (this.selectTimelineEntry.isNotHandledPhone) {
        return this.$i18next.t('history:viewInteractions.FAILED_CALL');
      }

      if (!!this.selectTimelineEntry.contactEntry.csrFirstname || !!this.selectTimelineEntry.contactEntry.csrLastname) {
        if (
          this.selectTimelineEntry.contactEntry.csrFirstname.indexOf(RESPONSE_AUTO_UUID) !== -1 ||
          this.selectTimelineEntry.contactEntry.csrLastname.indexOf(RESPONSE_AUTO_UUID) !== -1
        ) {
          return this.$i18next.t('history:viewInteractions.RESPONSE_AUTO');
        }

        if (!!this.selectTimelineEntry.contactEntry.csrLogin) {
          if (this.selectTimelineEntry.contactEntry.csrLogin.indexOf(EXTERNAL_ROUTING_NAME) !== -1) {
            return this.$i18next.t('history:viewInteractions.EXTERNAL_ROUTING');
          }
        }
      }

      if (
        this.selectTimelineEntry.contactEntry.csrFirstname === undefined ||
        this.selectTimelineEntry.contactEntry.csrLastname === undefined
      ) {
        return this.$i18next.t('commons:basic.campaignType.UNKNOWN');
      }

      return this.selectTimelineEntry.contactEntry.csrFirstname + ' ' + this.selectTimelineEntry.contactEntry.csrLastname;
    }
    return '';
  }

  getTimelineNotHandleReason(): string {
    if (
      !!this.selectTimelineEntry &&
      !!this.selectTimelineEntry.contactEntry &&
      this.selectTimelineEntry.contactEntry.notHandledReason === ContactEntryNotHandledReason.DISSUADED
    ) {
      return this.$i18next.t('history:viewInteractions.dissuaded_delay');
    }
    if (
      !!this.selectTimelineEntry &&
      !!this.selectTimelineEntry.contactEntry &&
      this.selectTimelineEntry.contactEntry.notHandledReason === ContactEntryNotHandledReason.ABANDONED
    ) {
      return this.$i18next.t('history:viewInteractions.abandoned_delay');
    }
    return '';
  }

  getTimelineNotHandledDelay(): string {
    if (
      !!this.selectTimelineEntry &&
      !!this.selectTimelineEntry.contactEntry &&
      isDefined(this.selectTimelineEntry.contactEntry.delayBeforeNotHandledReason)
    ) {
      let duration = this.selectTimelineEntry.contactEntry.delayBeforeNotHandledReason;
      let minutes = Math.floor(duration / (1000 * 60));
      let seconds = Math.floor((duration / 1000) % 60);
      return (
        (minutes < 10 ? '0' + minutes : minutes) +
        ' ' +
        this.$i18next.t('commons:basic.minutes.long') +
        ' ' +
        (seconds < 10 ? '0' + seconds : seconds) +
        ' ' +
        this.$i18next.t('commons:basic.seconds.long')
      );
    }
    return '';
  }

  getStatusOfVisioAppointment(): string {
    if (this.currentVisioAppointmentDetail && this.currentVisioAppointmentDetail.status !== undefined) {
      return this.$i18next.t('agent:contact.appointment.visio.status.' + AppointmentStatus[this.currentVisioAppointmentDetail.status]);
    }
    return '';
  }

  hasParticipantAvailable(): boolean {
    return (
      !!this.currentVisioAppointmentDetail &&
      (this.currentVisioAppointmentDetail.participants.length > 0 ||
        (this.currentVisioAppointmentDetail.awaitingParticipants && this.currentVisioAppointmentDetail.awaitingParticipants.length > 0))
    );
  }

  getVisioAppointmentParticipants(): string[] {
    if (this.currentVisioAppointmentDetail) {
      if (this.currentVisioAppointmentDetail.participants && this.currentVisioAppointmentDetail.participants.length > 0) {
        return this.currentVisioAppointmentDetail.participants.map((participant: IVisioAppointmentUser) =>
          this.extractNameFromVisioAppointmentUser(participant)
        );
      } else if (
        this.currentVisioAppointmentDetail.awaitingParticipants &&
        this.currentVisioAppointmentDetail.awaitingParticipants.length > 0
      ) {
        return this.currentVisioAppointmentDetail.awaitingParticipants.map(
          (participant: IVisioAppointmentUser) =>
            this.extractNameFromVisioAppointmentUser(participant) + this.$i18next.t('agent:contact.appointment.visio.awaiting')
        );
      } else {
        return [];
      }
    }
    return [];
  }

  extractNameFromVisioAppointmentUser(user: IVisioAppointmentUser): string {
    let name = '';
    if (user) {
      if (user.firstName || user.lastName) {
        name = user.firstName + ' ' + user.lastName;
      }
    }
    return name.toUpperCase().trim();
  }

  callContact() {
    if (!this.outCallRequested) {
      if (!!this.selectCustomer) {
        this.unitOutgoingCallDeprecatedService.openUnitOutgoingCallFormForContact(this.selectCustomer.id).then(() => {
          this.unitOutgoingCallDeprecatedService.finishAndClosePauseAndTask();
        });
      }
      this.bye();
    }
  }

  canOpenOutcall(): boolean {
    return this.unitOutgoingCallDeprecatedService.canOpenOutcall();
  }

  outcallDisabled(): boolean {
    return this.unitOutgoingCallDeprecatedService.outcallDisabled() && this.hasAPhoneNumber();
  }

  hasAPhoneNumber(): boolean {
    if (isDefined(this.selectContact)) {
      let contact = this.selectContact.get();
      return (
        contact &&
        contact.phoneNumber.length > 0 &&
        contact.phoneNumber.indexOf('SOCIAL_NETWORK_BASKET') === -1 &&
        isDefined(contact.customerId)
      );
    }
    return false;
  }

  get outCallRequested(): boolean {
    if (this.unitOutgoingCallDeprecatedService.unitOutgoingCall != null) {
      return this.unitOutgoingCallDeprecatedService.unitOutgoingCall.requested;
    }
    return false;
  }

  visioAppointmentActivated() {
    return (
      this.hasVisioAppointmentDetail &&
      !!this.currentVisioAppointmentDetail &&
      !!this.currentVisioAppointmentDetail.appointmentId &&
      this.currentVisioAppointmentDetail.status !== AppointmentStatus.CANCELLED &&
      this.currentVisioAppointmentDetail.status !== AppointmentStatus.REQUEST_CANCELLED
    );
  }

  canInviteColleague() {
    return (
      this.visioAppointmentActivated() &&
      !!this.currentVisioAppointmentDetail &&
      (!this.currentVisioAppointmentDetail.participants || this.currentVisioAppointmentDetail.participants.length === 0)
    );
  }

  inviteColleague() {
    if (this.hasVisioAppointmentDetail && !!this.currentVisioAppointmentDetail) {
      this.appointmentFacade.openAppointmentInvitationForm(this.currentVisioAppointmentDetail.appointmentId);
    }
  }

  canRescheduleAppointment(): boolean {
    return this.visioAppointmentActivated();
  }

  rescheduleAppointment() {
    if (this.hasVisioAppointmentDetail && !!this.currentVisioAppointmentDetail) {
      let campaignId: string = '';
      let timeSlot: TimeSlot =
        !!this.selectTimelineEntry && !!this.selectTimelineEntry.appointment && !!this.selectTimelineEntry.appointment.timeSlot
          ? this.selectTimelineEntry.appointment.timeSlot
          : ({
              id: 'simulatingTimeSlotId',
              beginDate: this.currentVisioAppointmentDetail.startDate.getTime(),
              endDate: this.currentVisioAppointmentDetail.endDate.getTime(),
              type: TimeSlotType.OPENED,
              contactThreshold: 1,
              contactCount: 1,
            } as TimeSlot);
      if (!!this.currentVisioAppointmentDetail && !!this.currentVisioAppointmentDetail.idCampaign) {
        campaignId = this.currentVisioAppointmentDetail.idCampaign;
      } else if (!!this.selectTimelineEntry && !!this.selectTimelineEntry.appointment && !!this.selectTimelineEntry.appointment.campaign) {
        campaignId = this.selectTimelineEntry.appointment.campaign.id;
      }
      if (campaignId.length > 0) {
        this.appointmentFacade.openAppointmentRescheduleForm(this.currentVisioAppointmentDetail.appointmentId, campaignId, timeSlot);
      }
    }
  }

  canCancelAppointment(): boolean {
    return this.visioAppointmentActivated();
  }

  cancelAppointment() {
    if (this.hasVisioAppointmentDetail && !!this.currentVisioAppointmentDetail) {
      this.appointmentFacade.openAppointmentCancellationForm(
        this.currentVisioAppointmentDetail.appointmentId,
        this.currentVisioAppointmentDetail.status
      );
    }
  }

  canJoinAppointment(): boolean {
    // when the detail of an appointment has been loaded and we know the flow uuid and appointment uuid and we are sure the status of appointment should no be cancelled
    if (!!this.currentVisioAppointmentDetail && this.visioAppointmentActivated()) {
      // when the current agent is the principle csr or one of the participants
      let participantsIds = !!this.currentVisioAppointmentDetail.participants
        ? this.currentVisioAppointmentDetail.participants.map(participant => participant.uuid)
        : [];
      if (!!this.currentVisioAppointmentDetail.csr) {
        participantsIds.push(this.currentVisioAppointmentDetail.csr.uuid);
      }
      // when the appointment will begin in less than five minutes (or has begun)
      if (participantsIds.indexOf(this.currentCsrId) > -1 && !!this.currentVisioAppointmentDetail.startDate) {
        return this.currentVisioAppointmentDetail.startDate.getTime() - new Date().getTime() < FIVE_MINUTES;
      }
    }
    return false;
  }

  joinAppointment() {
    if (
      this.hasVisioAppointmentDetail &&
      !!this.currentVisioAppointmentDetail &&
      !!this.currentVisioAppointmentDetail.flowUuid &&
      !!this.currentVisioAppointmentDetail.appointmentId
    ) {
      this.appointmentFacade.join(this.currentVisioAppointmentDetail.appointmentId, this.currentVisioAppointmentDetail.flowUuid);
      this.bye();
    }
  }

  canOpenHistoryInNewWindow(choosenInteraction: IContactEntry): boolean {
    return choosenInteraction && choosenInteraction.canalName === MediaType.MAIL;
  }

  openExternalHistory(interaction: any) {
    this.agentHistory.openExchangeInNewWindow(interaction);
  }

  private refreshTimelineInProcess(): void {
    this.selectContact.map(_contact =>
      this.agentHistory
        .findInProcess({ contact: _contact, entriesToMatch: [], from: 0, size: NB_INPROCESS_TO_LOAD })
        .subscribe((_result: ITimelineEntryResult) => {
          this.timelineInProcess = _result.timeline;
          this.timelineInProcessToDisplay = this.timelineInProcess.filter(
            tm => tm.canalName !== ChannelType.MAIL || tm.isEpticaSynchronized
          );
          this.maxPreviousInProcessExchanges = _result.total;
        })
    );
  }

  private refreshTimeline(
    contact: IContact,
    entriesInProcessToMatch: ITimelineEntry[] = [],
    entriesHistoToMatch: ITimelineEntry[] = [],
    onCompleted: () => void = () => {}
  ): void {
    merge(
      this.agentHistory.findInProcess({
        contact: contact,
        entriesToMatch: entriesInProcessToMatch,
        from: 0,
        size: NB_INPROCESS_TO_LOAD,
      }),

      this.agentHistory.findHistory({
        entriesToMatch: entriesHistoToMatch,
        from: 0,
        size: NB_HISTO_TO_LOAD,
        contact: contact,
      })
    ).subscribe(
      (result: ITimelineEntryResult) => {
        if (isUndefined(result)) return;

        if (!result.timeline || isUndefined(result.timeline)) return;

        let myVals = {};
        let value = result.timeline.filter((entry: ITimelineEntry) => {
          if (isUndefined(entry)) return false;
          // unique filter
          if (myVals[entry.id]) {
            return false;
          }
          myVals[entry.id] = true;
          return true;
        });

        switch (result.type) {
          case 'IN_PROCESS':
            this.timelineInProcess = value;
            this.timelineInProcessToDisplay = this.timelineInProcess.filter(
              tm =>
                tm.canalName !== 'MAIL' ||
                tm.isEpticaSynchronized ||
                tm.visibilityType === ContactEntryVisibilityType.PRIVATE ||
                tm.visibilityType === 'PRIVATE'
            );
            this.maxPreviousInProcessExchanges = result.total;
            break;
          case 'HISTO':
            this.timelineHisto = value;
            this.maxPreviousExchanges = result.total;
            break;
          default:
            break;
        }
      },
      (error: any) => this.$log.error('[ContactViewHistoPopin] error in refreshTimeline [' + error + ']'),
      onCompleted
    );
  }

  private displayCurrentEpticaFrame(_epticaRequestId: string) {
    if (this.agentConfigDeprecatedService.hasChannel(ChannelType.MAIL) || !this.checkVisibilityMail) {
      if (isDefined(_epticaRequestId) && _epticaRequestId !== '') {
        this.epticaPromise = this.epticaDeprecatedService.loadRequest({
          requestId: parseInt(_epticaRequestId, 10),
          responseId: this.responseId,
        });
        this.epticaPromise.then((request: IEpticaRequestFrame) => {
          this.epticaFrameIds.push(request.getId() + '');
          request
            .retrieveConversationalEvents()
            .pipe(ng1Destroy(this))
            .subscribe(events => (this.mailEvents = events));
        });
      }
    }
  }

  private displayCurrentDimeloFrame(contactEntry: IContactEntry) {
    if (contactEntry.dimeloRequestId && !!contactEntry.dimeloRequestId) {
      this.socialNetworkService.getExchangeHisto(contactEntry.dimeloRequestId).then((request: any) => {
        this.dimeloEvents = request;
      });
    }
  }

  private changeContactEntry(_row: ITimelineEntry, mode: HistoryPopinMode) {
    this.timelineTreatment = [];
    this.currentQualifContactList = [];
    this.mailEvents = [];
    this.dimeloEvents = [];
    this.hasVisioAppointmentDetail = false;
    this.selectTimelineEntry = _row;
    this.displayReopen = false;
    this.selectSkills =
      this.selectTimelineEntry && this.selectTimelineEntry.contactEntry
        ? this.selectTimelineEntry.contactEntry.skills.map((skill: Skill) => skill.name)
        : [];

    if (this.checkVisibilityMail) {
      if (
        this.selectTimelineEntry.canalName === ChannelType[ChannelType.MAIL] &&
        this.selectTimelineEntry.canalDirection === ChannelDirection[ChannelDirection.INCOMING] &&
        ((this.selectTimelineEntry.hasVisibility &&
          !this.sessionDeprecatedService.hasPermission('CSR_MAIL_INCOMING::mail_in_process_with_skill:display')) ||
          (!this.selectTimelineEntry.hasVisibility &&
            !this.sessionDeprecatedService.hasPermission('CSR_MAIL_INCOMING::mail_in_process_without_skill:display')))
      ) {
        this.historyPopinMode = 'NOT_ALLOWED';
        return;
      } else {
        this.historyPopinMode = mode;
      }
    } else {
      this.historyPopinMode = mode;
    }

    if (this.selectTimelineEntry && this.selectTimelineEntry.contactEntry) {
      this.agentImageService.loadImage(this.selectTimelineEntry.contactEntry.csrUuid);
      // manage reopen mail flag
      this.displayReopen =
        this.applicationId === TileId.CSR && this.selectTimelineEntry.contactEntry.canalName === ChannelType[ChannelType.MAIL];
      if (mode === 'HISTO') {
        this.entryState = this.selectTimelineEntry.contactEntry.interactionStatus || '';
        // manage disableReopen flag according to current other contacts
        this.contactFacade.bookings$
          .pipe(
            ng1Destroy(this),
            map(contacts => contacts.some(({ channel }) => ChannelUtil.equals(ChannelUtil.INCOMING_BASKET, channel)))
          )
          .subscribe(incomingMail => (this.disableReopen = incomingMail));

        let contents = this.getCurrentContents();
        // we only display the qualif part if at least one form is available
        if (
          isDefined(this.selectTimelineEntry) &&
          this.selectTimelineEntry.canalName !== ChannelType[ChannelType.SMS] &&
          this.selectTimelineEntry.canalName !== ChannelType[ChannelType.CHAT_IADVIZE]
        ) {
          if (this.selectTimelineEntry && contents && isArray(contents)) {
            for (let i: number = 0; i < contents.length; i++) {
              let element = contents[i];
              if (isDefined(element.content) && element.contentType === 'FORM') {
                this.currentQualifContactList.push(this.selectTimelineEntry.contactEntry);
                break;
              }
            }
          }
        }
        this.showQualification =
          this.selectTimelineEntry.canalName === ChannelType[ChannelType.PHONE] ||
          this.selectTimelineEntry.canalName === ChannelType[ChannelType.MAIL];
      }

      switch (this.selectTimelineEntry.canalName) {
        case ChannelType[ChannelType.UNITARY_PHONE]:
        case ChannelType[ChannelType.PHONE]:
          if (mode !== 'HISTO' || this.sessionDeprecatedService.hasPermission('HISTORIZATION::historization_interaction:listen')) {
            this.getNewRecord(this.selectTimelineEntry.contactEntry.technicalId);
          }
          break;
        case ChannelType[ChannelType.MAIL]:
          this.hasRecord = false;
          this.displayCurrentEpticaFrame(`${this.selectTimelineEntry.contactEntry.epticaRequestId}`);
          break;
        case ChannelType[ChannelType.SOCIAL_NETWORK]:
          this.hasRecord = false;
          this.displayCurrentDimeloFrame(this.selectTimelineEntry.contactEntry);
          break;
        case ChannelType[ChannelType.CHAT]:
          this.initCurrentChatChatbotDiscussion();
          break;
        case ChannelType[ChannelType.CHATBOT]:
          this.initCurrentChatChatbotDiscussion();
          break;
        case ChannelType[ChannelType.VISIO]:
          this.hasRecord = false;
          // Temporary used for identify if this visio contact entry has the record
          this.getNewRecord(this.selectTimelineEntry.contactEntry.technicalId);
          if (
            this.selectTimelineEntry.contactEntry &&
            this.selectTimelineEntry.contactEntry.extraData &&
            this.selectTimelineEntry.contactEntry.extraData.hasOwnProperty('visio_contact_uuid') &&
            typeof this.selectTimelineEntry.contactEntry.extraData['visio_contact_uuid'] === 'string' &&
            this.selectTimelineEntry.contactEntry.extraData['visio_contact_uuid'].length > 0
          ) {
            this.openTargetVisioAppointmentDetail(this.selectTimelineEntry.contactEntry.extraData['visio_contact_uuid']);
          }
        default:
          this.hasRecord = false;
      }

      this.getNewTreatments(this.selectTimelineEntry.contactEntry);
    } else if (
      this.selectTimelineEntry &&
      this.selectTimelineEntry.appointment &&
      this.selectTimelineEntry.appointment.campaignType === this.getCampaignType('VISIO_SCHEDULED_CALL_BACK')
    ) {
      this.hasRecord = false;
      this.openTargetVisioAppointmentDetail(this.selectTimelineEntry.appointment.idContact);
    }
  }

  private openTargetVisioAppointmentDetail(contactUuid: string) {
    this.appointmentDeprecatedService.searchAppointmentsByContact(contactUuid).subscribe(
      (result: IVisioAppointmentDetail[]) => {
        this.currentVisioAppointmentDetail = result.length > 0 ? result[0] : undefined;
        this.hasVisioAppointmentDetail = result.length > 0 ? true : false;
        this.selectSkills =
          this.hasVisioAppointmentDetail && this.currentVisioAppointmentDetail
            ? this.currentVisioAppointmentDetail.skillList.map((skill: Skill) => skill.name)
            : [];
      },
      (error: any) => this.$log.error('[ContactViewHistoPopin] error in openTargetVisioAppointmentDetail [' + error + ']'),
      () => {}
    );
  }

  private initCurrentChatChatbotDiscussion() {
    if (!!this.selectTimelineEntry && !!this.selectTimelineEntry.contactEntry) {
      this.chatService.getChatDiscussions(this.selectTimelineEntry.contactEntry.chatConversationUuid).then(
        discussion => {
          this.currentChatDiscussion = discussion;
          this.currentChatDiscussion.messages = this.currentChatDiscussion.messages.filter(
            message => message.content != null && message.content.length !== 0
          );
        },
        err => {
          this.$log.error(
            '[ContactViewHistoInteractionsPopinCtrl] error in get discussions from chat-solution project for chat/chatbot conversation id ' +
              this.selectTimelineEntry!.contactEntry!.chatConversationUuid +
              '(' +
              err +
              ')'
          );
        }
      );
    }
  }

  private getCurrentContents() {
    return Option.of(this.selectTimelineEntry)
      .flatMap((timelineEntry: ITimelineEntry) => Option.of(timelineEntry.contactEntry))
      .map((entry: IContactEntry) => entry.contents)
      .getOrElse([]);
  }

  reopenMailCallback(): void {
    if (!!this.epticaPromise) {
      this.epticaPromise.then(
        request => {
          // reopen the mail (change status/date contact side )
          this.mailFacade.reopen('' + request.getId(), { param: {} });

          // close this popin
          this.bye();
        },
        err => {
          this.$log.error(JSON.stringify(err));
        }
      );
    }
  }

  private getEpticaRequestId(): string | undefined {
    if (!!this.selectTimelineEntry && !!this.selectTimelineEntry.contactEntry) {
      return this.selectTimelineEntry.contactEntry.epticaRequestId;
    }
    return undefined;
  }

  isMail(): boolean {
    if (this.selectTimelineEntry) {
      return this.selectTimelineEntry.canalName === ChannelType[ChannelType.MAIL];
    }
    return false;
  }
}

export class ContactViewHistoPopin implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    close: '&',
    resolve: '&',
  } as { [binding: string]: string };

  controller = [
    '$log',
    'sessionDeprecatedService',
    'recordDeprecatedService',
    'agentHistory',
    'appointmentDeprecatedService',
    'epticaDeprecatedService',
    'messaging',
    'agentConfigDeprecatedService',
    'contactDeprecatedService',
    'momentService',
    'modalService',
    'loaderDeprecatedService',
    'socialNetworkService',
    'chatService',
    'chatbotService',
    '$i18next',
    'chatEmojiService',
    'unitOutgoingCallDeprecatedService',
    'profileFacade',
    'appointmentFacade',
    '$sce',
    'chatMessageUtilService',
    'agentImageService',
    'profileService',
    'basketStore',
    'contactFacade',
    'mailFacade',
    'tileFacade',
    'customerFacade',
    'historyService',
    ContactViewHistoInteractionsPopinCtrl,
  ];
}

export default MODULE_NAME;
